<template>
  <footer>
    <div class="footer-container">
      <div class="nav-wrapper">
        <div class="nav-wrapper-row">
          <!-- 关于我们 -->
          <div class="nav-block" :style="{ marginRight: isMobile ? '0' : '20px' }">
            <span class="nav-block-title">关于我们</span>
            <div class="nav-block-content">
              <div class="nav-item">
                <a href="/about" rel="nofollow"><p>公司介绍</p></a>
              </div>
            </div>
          </div>

          <!-- 版权登记 -->
          <div class="nav-block" :style="{ marginRight: isMobile ? '0' : '' }">
            <span class="nav-block-title">版权登记</span>
            <div class="nav-block-content">
              <div class="nav-item">
                <a href="/software" rel="nofollow"><p>软件著作权</p></a>
                <hr />
                <a href="/product" rel="nofollow"><p>作品著作权</p></a>
              </div>
            </div>
          </div>

          <!-- 电子版权认证 -->
          <div class="nav-block" :style="{ width: isMobile ? 'auto' : '85px', marginRight: isMobile ? '0' : '' }">
            <span class="nav-block-title">版权认证</span>
            <div class="nav-block-content">
              <div class="nav-item">
                <a href="/certificate" rel="nofollow"><p>服务介绍</p></a>
                <hr />
                <a href="/certificate" rel="nofollow"><p>办理流程</p></a>
                <hr />
                <a href="/certificate" rel="nofollow"><p>办理材料</p></a>
              </div>
            </div>
          </div>

          <!-- 联系管家 -->
          <div class="nav-block" :style="{ width: isMobile ? 'auto' : '146px', marginRight: isMobile ? '0' : '' }">
            <span class="nav-block-title">联系管家</span>
            <div class="nav-block-content">
              <div class="nav-item">
                <p>7×24小时管家服务</p><hr />
                <p>kanglei@qixiaohu.cn</p>
              </div>
            </div>
          </div>



          <div class="contact-wechat-row">
            <!-- 联系表单 -->
            <div
              id="contact_div"
              class="nav-block contact-block"
              :class="{ 'mobile-input': isMobile }"
              :style="{ width: isMobile ? '100%' : 'auto', marginRight: isMobile ? '0' : '0' }"
            >
              <div class="bottomiInput_right">
                <p style="font-size: 14px">
                  请留下您的联系信息，我们会尽快安排专属管家为您提供定制化服务
                </p>
                <form @submit.prevent="handleSubmit">
                  <div :class="{ 'mobile-form-row': isMobile }">
                    <label for="name">姓名</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      v-model="name"
                      required
                      :style="{ width: isMobile ? '100%' : '145px', marginRight: isMobile ? '0' : '25px', marginBottom: isMobile ? '10px' : '0' }"
                    />
                    <label for="tel" :style="{ display: isMobile ? 'block' : 'inline' }">电话</label>
                    <input
                      type="text"
                      id="tel"
                      name="tel"
                      v-model="tel"
                      required
                      :style="{ width: isMobile ? '100%' : '207px' }"
                    />
                  </div>
                  <div>
                    <label for="note">留言</label>
                    <input
                      type="text"
                      id="note"
                      name="note"
                      required
                      :style="{ width: isMobile ? '100%' : '300px', marginRight: isMobile ? '0' : '10px', marginBottom: isMobile ? '10px' : '0' }"
                      v-model="note"
                    />
                    <button type="submit" :style="{ width: isMobile ? '100%' : 'auto' }">立即联系管家</button>
                  </div>
                  <div>
                    <p>*信息保护中，请放心填写*</p>
                  </div>
                </form>
              </div>
            </div>
            <!-- 扫码加微信 -->
            <div
              id="wechat_div"
              class="nav-block wechat-block"
              :style="{ marginLeft: isMobile ? '0' : '0', marginRight: isMobile ? '0' : '0', width: isMobile ? '100%' : 'auto' }"
            >
              <div :style="{ paddingLeft: isMobile ? '0' : '35px' }">扫码加微信</div>
              <img src="@/assets/qrcode-03.jpg" class="wechaterweima" />
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- 底部信息 -->
    <div class="sub">
      <div class="company" :style="{ marginRight: isMobile ? '0' : '60px', display: isMobile ? 'block' : 'inline' }">
        公司地址：北京市顺义区金穗路2号院8号楼4层（宏远航城广场E座）
      </div>
      <div class="bqsy" :style="{ display: isMobile ? 'block' : 'inline' }">
        版权所有：北京智链创新科技有限公司
        <span :style="{ marginLeft: isMobile ? '0' : '60px', display: isMobile ? 'block' : 'inline', marginTop: isMobile ? '10px' : '0' }">
          京ICP备2024074692号-1
        </span>
        <span
          class="police-record"
          :style="{ marginLeft: isMobile ? '0' : '60px', display: isMobile ? 'block' : 'inline-flex', marginTop: isMobile ? '10px' : '0' }"
        >
          <img src="@/assets/gong_an.png" alt="公安备案" />
          京公网安备11011302007654号
        </span>
      </div>
    </div>
  </footer>
</template>

<script>
import qs from "qs";
export default {
  name: "footercommon",
  components: {},
  data() {
    return {
      name: "",
      tel: "",
      note: "",
      isMobile: false // 用于判断是否为移动设备
    };
  },
  methods: {
    handleSubmit() {
      const url = "/api/AddleavingServlet";
      let str = {
        name: this.name,
        phone: this.tel,
        message: this.note,
      };
      let str1 = qs.stringify(str);
      this.axios
        .post(url, str1)
        .then((res) => {
          this.$message({
            message: "留言成功！",
            type: "success",
          });
        })
        .catch((err) => {
          this.$message({
            message: "失败！请检查网络",
            type: "warning",
          });
        });
    },
    // 检测屏幕尺寸
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768;
    }
  },
  mounted() {
    // 初始化检测
    this.checkScreenSize();
    // 监听窗口大小变化
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('resize', this.checkScreenSize);
  }
};
</script>

<style lang="less">
.wechaterweima {
  width: 100px;
  height: 100px;
  margin-left: 20px;
  margin-top: 10px;
}

footer {
  background: #111;
  color: #fff;
  font-size: 14px !important;
  overflow: hidden;
  padding-top: 36px !important;
  position: relative;
}

footer .footer-container {
  display: flex;
  justify-content: center;
  margin: 0 auto 30px;
  max-width: 1300px;
  padding-bottom: 30px;
}

footer a:hover {
  text-decoration: underline;
}

footer .nav-wrapper {
  display: inline-block;
  max-width: 1200px;
  vertical-align: top;
}

footer .nav-wrapper .nav-wrapper-row {
  display: flex;
  justify-content: space-between;
  margin-top: -16px;
  margin-right: 150px;
  flex-wrap: nowrap; /* 保持同一行展示 */
  align-items: flex-start;
}

footer .nav-wrapper .nav-wrapper-row a {
  color: #fff;
}

footer .nav-wrapper .nav-wrapper-row .nav-item {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

footer .nav-wrapper .nav-block {
  display: inline-block;
  margin-right: 60px;
  vertical-align: top;
  width: 116px;
  margin-bottom: 20px; /* 增加底部间距，便于换行后布局 */
}

footer .nav-wrapper .nav-block > .nav-block-title {
  color: #fff;
  display: block;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  margin-bottom: 16px;
}

footer .nav-wrapper .nav-block .nav-item {
  color: #fff;
  cursor: pointer;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 12px;
  margin-right: 12px;
}

footer .nav-wrapper .nav-block .nav-item a {
  color: #fff;
  display: inline-block;
  text-decoration: none;
  transition: opacity 0.2s;
}

footer .nav-wrapper .nav-block .nav-item a:hover {
  opacity: 1;
}

/* 联系表单样式 */
.bottomiInput {
  // margin: auto;
}
.mobile-input {
  margin: auto;
}

.bottomiInputBox {
  width: 100%;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  border-left: 1px solid #eee;
  padding-left: 60px;
}

.bottomiInput_right {
  width: 500px;
  margin-top: -10px;
  line-height: 40px;
}

.bottomiInput_right label {
  font-size: 16px;
  margin-right: 7px;
}

input[type="text"] {
  border-radius: 3px;
  height: 24px;
  width: 100%; /* 默认占满宽度，通过内联样式覆盖 */
}

.bottomiInput_right button {
  border-radius: 3px;
  background-color: #4fabdf;
  color: #fff;
  padding: 4.5px 20px;
  border: none;
  cursor: pointer;
}

input[type="text"]:focus {
  outline: none;
}

/* 底部信息样式 */
.sub {
  text-align: center;
  opacity: 0.6;
  font-size: 12px;
  padding-bottom: 30px;
}

.police-record {
  align-items: center;
  column-gap: 6px;
  img {
    height: 16px;
    width: auto;
    display: inline-block;
  }
}

.contact-wechat-row {
  display: flex;
  align-items: flex-start;
  column-gap: 20px;
  flex-wrap: nowrap;
  flex-shrink: 0;
}

.contact-block {
  width: auto;
  margin-right: 0;
  flex: 1 1 auto;
}

.wechat-block {
  width: auto;
  margin-right: 0;
  flex-shrink: 0;
}

/* 响应式样式 */
@media screen and (max-width: 1024px) {
  footer .nav-wrapper .nav-wrapper-row {
    margin-right: 50px;
  }
  
  .bottomiInputBox {
    padding-left: 30px;
  }
  
  .bottomiInput_right {
    width: 400px;
  }
}

@media screen and (max-width: 768px) {
  .nav-wrapper {
    padding: 0 20px; /* 增加内边距 */
  }
  
  footer .nav-wrapper .nav-wrapper-row {
    margin-right: 0;
    flex-direction: column; /* 垂直排列 */
    align-items: center; /* 居中对齐 */
  }
  
  footer .nav-wrapper .nav-block {
    margin-right: 0;
    width: 100%; /* 占满宽度 */
    text-align: center; /* 文本居中 */
  }
  
  .bottomiInputBox {
    border-left: none;
    padding-left: 0;
    justify-content: center;
  }
  
  .bottomiInput_right {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }

  .contact-wechat-row {
    flex-direction: column;
    row-gap: 16px;
    align-items: center;
  }
  
  .mobile-form-row {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  
  .wechaterweima {
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
}

@media screen and (max-width: 480px) {
  footer {
    padding-top: 20px !important;
  }
  
  .nav-block-title {
    font-size: 16px !important;
    margin-bottom: 10px !important;
  }
  
  .bottomiInput_right p {
    font-size: 12px;
    line-height: 1.5;
  }
  
  input[type="text"] {
    height: 30px;
  }
  
  .bottomiInput_right button {
    width: 100%;
    padding: 8px 0;
  }
}
</style>
